/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Agenda_TitleInputs */

const cs_calendar_agenda_title = /** @type {(inputs: Calendar_Agenda_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenda`)
};

const en_calendar_agenda_title = /** @type {(inputs: Calendar_Agenda_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenda`)
};

/**
* | output |
* | --- |
* | "Agenda" |
*
* @param {Calendar_Agenda_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_agenda_title = /** @type {((inputs?: Calendar_Agenda_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Agenda_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_agenda_title(inputs)
	return cs_calendar_agenda_title(inputs)
});